module.exports = __webpack_public_path__ + "assets/img/blindBoxBtn1.226a2cc7.png";